import { render, staticRenderFns } from "./shop_money.vue?vue&type=template&id=058435a0&scoped=true"
import script from "./shop_money.vue?vue&type=script&lang=ts"
export * from "./shop_money.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058435a0",
  null
  
)

export default component.exports